import { Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProviders } from "@/context/AppContext";
import Portfolio from "@/pages/Portfolio";
import AdminApp from "@/admin/AdminApp";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 48, fontFamily: "sans-serif" }}>
          Something went wrong.{" "}
          <a href="/" style={{ color: "#2563EB" }}>
            Reload
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/admin" element={<AdminApp />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AppProviders>
    </ErrorBoundary>
  );
}

export default App;
